// Add event listeners to all form inputs
document.getElementById("licenseHolder").addEventListener("change", updateQuote);
document.getElementById("firingPointsType").addEventListener("change", updateQuote);
document.getElementById("totalFiringPoints").addEventListener("change", updateQuote);
document.getElementById("MM100Quantity").addEventListener("change", updateQuote);
document.getElementById("MM200Quantity").addEventListener("change", updateQuote);
document.getElementById("TVSize").addEventListener("change", updateQuote);
document.getElementById("aimingMask").addEventListener("change", updateQuote);
document.getElementById("athleteStands").addEventListener("change", updateQuote);
document.getElementById("onsiteInstallation").addEventListener("change", updateQuote);

// Function to handle quantity button clicks
function updateQuantity(item, change) {
    let quantityInput = document.getElementById(`${item}Quantity`);
    let currentValue = parseInt(quantityInput.value);
    let newValue = Math.max(0, currentValue + change); // Prevent negative values
    quantityInput.value = newValue;
    updateQuote();
}

// Main function to update the quote
function updateQuote() {
    let firingPoints = parseInt(document.getElementById("totalFiringPoints").value) || 0;
    let licenseHolder = document.getElementById("licenseHolder").value;
    let firingType = document.getElementById("firingPointsType").value;
    let MM100Displays = parseInt(document.getElementById("MM100Quantity").value) || 0;
    let MM200Timers = parseInt(document.getElementById("MM200Quantity").value) || 0;
    let TVSize = document.getElementById("TVSize").value;
    let aimingMask = document.getElementById("aimingMask").value;
    let athleteStands = document.getElementById("athleteStands").value;
    let onsiteInstallation = document.getElementById("onsiteInstallation").value;

    // Orion License
    let licenseQuantity = licenseHolder === "yes" ? 0 : 1; // If they're a license holder, they don't need a new license
    let licenseSubtotal = licenseQuantity * 175;
    document.getElementById("licenseQuantity").innerText = licenseQuantity;
    document.getElementById("licenseSubtotal").innerText = `$${licenseSubtotal}`;

    // Firing Points (NC100 / NC200)
    let firingPointPrice = firingType === "NC100 - Air Rifle/Air Pistol" ? 1720 : 1720;
    let firingSubtotal = firingPoints * firingPointPrice;
    document.getElementById("selectedItem").innerText = firingType;
    document.getElementById("itemQuantity").innerText = firingPoints;
    document.getElementById("itemSubtotal").innerText = `$${firingSubtotal}`;

    // Items that scale with Firing Points    
    updateLineItem("athleteMonitor", firingPoints, 515);
    updateLineItem("paperRolls", firingPoints * 2, 13);    
    updateLineItem("backMask", firingPoints, 20);    

    // Aiming Masks - update text dynamically based on selection
    let aimingMaskText = "Aiming Masks";
    if (aimingMask === "airRifle") {
        aimingMaskText = "Air Rifle Aiming Masks";
    } else if (aimingMask === "airPistol") {
        aimingMaskText = "Air Pistol Aiming Masks";
    } else if (aimingMask === "smallbore") {
        aimingMaskText = "Indoor Smallbore Rifle Aiming Masks";
    }
    document.getElementById("aimingMaskQuantity").innerText = firingPoints;
    document.getElementById("aimingMaskSubtotal").innerText = `$${firingPoints * 20}`;
    // Update the Aiming Masks text dynamically
    document.querySelector(".item-row:has(#aimingMaskQuantity) .item-name").innerText = aimingMaskText;
  
    // Athlete Stands
    let standQuantity = athleteStands === "none" ? 0 : firingPoints;
    let standPrice = 0;
    let standText = "Athlete Stands";
    
    if (athleteStands === "none") {
        standText = "Athlete Stands (None Selected)";
    } else if (athleteStands === "monitorStand") {
        standPrice = 150;
        standText = "Monitor Stand for DoW100";
    } else if (athleteStands === "3pTable") {
        standPrice = 310;
        standText = "Stand for 3 and 4 Position Rifle";
    } else if (athleteStands === "internationalTable") {
        standPrice = 310;
        standText = "Stand for International Rules";
    }
    
    document.getElementById("standQuantity").innerText = standQuantity;
    document.getElementById("standSubtotal").innerText = `$${standQuantity * standPrice}`;
    // Update the Athlete Stands text dynamically
    document.querySelector(".item-row:has(#standQuantity) .item-name").innerText = standText;

    // MM100 Spectator Displays
    document.getElementById("mm100Quantity").innerText = MM100Displays;
    document.getElementById("mm100Subtotal").innerText = `$${MM100Displays * 295}`;

    // TV for Spectator Display
    let tvQuantity = MM100Displays;
    let tvPrice = 0;
    let tvSizeText = "TV for Spectator Display";
    
    if (TVSize === "42") {
        tvPrice = 250;
        tvSizeText = "42 inch TV for Spectator Display";
    } else if (TVSize === "55") {
        tvPrice = 350;
        tvSizeText = "55 inch TV for Spectator Display";
    } else if (TVSize === "75") {
        tvPrice = 900;
        tvSizeText = "75 inch TV for Spectator Display";
    } else if (TVSize === "none") {
        tvSizeText = "TV for Spectator Display (None Selected)";
    }
    
    document.getElementById("tvQuantity").innerText = tvQuantity;
    document.getElementById("tvSubtotal").innerText = `$${tvQuantity * tvPrice}`;
    // Update the TV size text dynamically
    document.querySelector(".item-row:has(#tvQuantity) .item-name").innerText = tvSizeText;

    // MM200 Range Timers
    document.getElementById("mm200Quantity").innerText = MM200Timers;
    document.getElementById("mm200Subtotal").innerText = `$${MM200Timers * 390}`;

    // Range Power Cables - New logic based on firing points
    let powerCableQuantity = 0;
    let powerCablePrice = 0;
    
    if (firingPoints > 0) {
        if (firingPoints <= 6) {
            powerCableQuantity = 2;
            powerCablePrice = 140;
        } else if (firingPoints <= 10) {
            powerCableQuantity = 2;
            powerCablePrice = 180;
        } else if (firingPoints <= 16) {
            powerCableQuantity = 4;
            powerCablePrice = 320;
        } else {
            powerCableQuantity = 4;
            powerCablePrice = 360;
        }
    }
    
    document.getElementById("powerCableQuantity").innerText = powerCableQuantity;
    document.getElementById("powerCableSubtotal").innerText = `$${powerCablePrice}`;
      
    // Network Manager selection based on firing points
    let networkManager = firingPoints > 12 ? "Athena Networking Equipment" : "Athena Networking Equipment";
    let networkManagerPrice = firingPoints > 12 ? 3000 : 2000;
    document.getElementById("networkQuantity").innerText = firingPoints > 0 ? 1 : 0;
    document.getElementById("networkSubtotal").innerText = `$${firingPoints > 0 ? networkManagerPrice : 0}`;
    // Update the Network Manager text dynamically
    document.querySelector(".item-row:has(#networkQuantity) .item-name").innerText = networkManager;

    // Calculate the total
    calculateTotal();
}

// Helper function to update line items
function updateLineItem(itemId, quantity, unitPrice) {
    document.getElementById(`${itemId}Quantity`).innerText = quantity;
    document.getElementById(`${itemId}Subtotal`).innerText = `$${quantity * unitPrice}`;
}

// Function to calculate subtotal, shipping and final total
function calculateTotal() {
    // Get all subtotals from the item rows (excluding the total rows)
    let subtotal = 0;
    const itemRows = document.querySelectorAll('.item-row:not(.total-row)');
    
    itemRows.forEach(row => {
        const subtotalElement = row.querySelector('.item-subtotal');
        if (subtotalElement) {
            const value = parseFloat(subtotalElement.innerText.replace('$', '')) || 0;
            subtotal += value;
        }
    });

    // Calculate shipping based on firing points
    let firingPoints = parseInt(document.getElementById("totalFiringPoints").value) || 0;
    let shippingCost = firingPoints > 0 ? (firingPoints * 80) : 0;

    // Calculate final total
    let finalTotal = subtotal + shippingCost;

    // Update displayed values
    document.getElementById("subtotalAmount").innerText = `$${subtotal}`;
    document.getElementById("shippingAmount").innerText = `$${shippingCost}`;
    document.getElementById("finalTotalAmount").innerText = `$${finalTotal}`;
}

// Email JS functionality
function sendEmail() {
    // Show loading state
    const submitButton = document.getElementById("submitQuote");
    const originalButtonText = submitButton.innerText;
    submitButton.innerText = "Sending...";
    submitButton.disabled = true;
    
    // Collect customer info
    const firstName = document.querySelector("input[name='first_name']").value;
    const lastName = document.querySelector("input[name='last_name']").value;
    const email = document.querySelector("input[name='email']").value;
    const phone = document.querySelector("input[name='phone']").value;  
    const reference = document.querySelector("input[name='reference']").value;  
    
    // Validate required fields
    if (!firstName || !lastName || !email || !phone) {
        alert("Please fill in all required fields (First Name, Last Name, Email, Phone)");
        submitButton.innerText = originalButtonText;
        submitButton.disabled = false;
        return;
    }
    
    // Collect form selections
    const licenseHolder = document.getElementById("licenseHolder").value;
    const firingPointsType = document.getElementById("firingPointsType").value;
    const totalFiringPoints = document.getElementById("totalFiringPoints").value;
    const MM100Quantity = document.getElementById("MM100Quantity").value;
    const MM200Quantity = document.getElementById("MM200Quantity").value;
    const TVSize = document.getElementById("TVSize").value;
    const aimingMask = document.getElementById("aimingMask").value;
    const athleteStands = document.getElementById("athleteStands").value;
    const onsiteInstallation = document.getElementById("onsiteInstallation").value;
    
    // Collect price information
    const subtotalAmount = document.getElementById("subtotalAmount").innerText;
    const shippingAmount = document.getElementById("shippingAmount").innerText;
    const finalTotalAmount = document.getElementById("finalTotalAmount").innerText;
    
    // Create table of selected items
    let lineItems = [];
    const itemRows = document.querySelectorAll('.item-row:not(.total-row)');
    
    itemRows.forEach(row => {
        const itemName = row.querySelector('.item-name').innerText;
        const itemQuantity = row.querySelector('.item-quantity').innerText;
        const itemSubtotal = row.querySelector('.item-subtotal').innerText;
        
        // Only include items with non-zero quantity
        if (itemQuantity && parseInt(itemQuantity) > 0) {
            lineItems.push({
                name: itemName,
                quantity: itemQuantity,
                subtotal: itemSubtotal
            });
        }
    });
    
    // Build line items HTML table for email
    let lineItemsHTML = '<table style="width: 100%; border-collapse: collapse; margin-top: 20px;">';
    lineItemsHTML += '<tr style="background-color: #eee;"><th style="padding: 8px; text-align: left; border: 1px solid #ddd;">Item</th><th style="padding: 8px; text-align: center; border: 1px solid #ddd;">Quantity</th><th style="padding: 8px; text-align: right; border: 1px solid #ddd;">Price</th></tr>';
    
    lineItems.forEach(item => {
        lineItemsHTML += `<tr><td style="padding: 8px; border: 1px solid #ddd;">${item.name}</td><td style="padding: 8px; text-align: center; border: 1px solid #ddd;">${item.quantity}</td><td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${item.subtotal}</td></tr>`;
    });
    
    // Add totals
    lineItemsHTML += `<tr style="background-color: #f9f9f9;"><td colspan="2" style="padding: 8px; text-align: right; border: 1px solid #ddd;"><strong>Subtotal</strong></td><td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${subtotalAmount}</td></tr>`;
    lineItemsHTML += `<tr style="background-color: #f9f9f9;"><td colspan="2" style="padding: 8px; text-align: right; border: 1px solid #ddd;"><strong>Shipping</strong></td><td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${shippingAmount}</td></tr>`;
    lineItemsHTML += `<tr style="background-color: #e6f7ff;"><td colspan="2" style="padding: 8px; text-align: right; border: 1px solid #ddd;"><strong>Total</strong></td><td style="padding: 8px; text-align: right; border: 1px solid #ddd;">${finalTotalAmount}</td></tr>`;
    lineItemsHTML += '</table>';
    
    // Prepare the email template parameters
    const templateParams = {
        first_name: firstName,
        last_name: lastName,
        email: email,
        phone: phone,   
        reference: reference,     
        license_holder: licenseHolder,
        firing_points_type: firingPointsType,
        total_firing_points: totalFiringPoints,
        mm100_quantity: MM100Quantity,
        mm200_quantity: MM200Quantity,
        tv_size: TVSize,
        aiming_mask: aimingMask,
        athlete_stands: athleteStands,
        installation: onsiteInstallation,
        subtotal: subtotalAmount,
        shipping: shippingAmount,
        total: finalTotalAmount,
        line_items: lineItemsHTML
    };
    
    // Send the email using EmailJS
    // Replace these values with your actual EmailJS service ID and template ID
    const serviceID = 'service_ch3gqlj';
    const templateID = 'template_tplb8t8';
    const userID = 'jMvYRMtMd_HgrvELu';
    
    emailjs.send(serviceID, templateID, templateParams, userID)
        .then(function(response) {
            // Success
            console.log('SUCCESS!', response.status, response.text);
            document.getElementById("confirmationMessage").style.display = 'block';
            submitButton.innerText = "Quote Sent!";
            
            // Reset form after a delay
            setTimeout(() => {
                submitButton.innerText = originalButtonText;
                submitButton.disabled = false;
            }, 3000);
        }, function(error) {
            // Error
            console.log('FAILED...', error);
            alert("There was an error sending your quote. Please try again.");
            submitButton.innerText = originalButtonText;
            submitButton.disabled = false;
        });
}

// Initialize the form on page load
document.addEventListener('DOMContentLoaded', function() {
    updateQuote();
    
    // Add submit event listener
    document.getElementById("submitQuote").addEventListener("click", sendEmail);
});